// @packages
import React, { useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-native';

// @scripts
import { View } from 'react-native';
import Button from '../../atoms/button';
import Input from '../../atoms/input';
import { config } from '../../../core/config';
import { forgotPasswordSubmit } from '../../../services/login-service';
import { globalUI } from '../../../core';
import { routesOutLogged } from '../../../core/routes/config';
import { useAuth } from '../../../core/context/provider';
import { Durations } from '../../../utils/types';
import useStyles from './styles';

const ForgotPasswordRecoveryPassword = () => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState<boolean>();
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm();
  const { userForgotPassword } = useAuth();

  const onSubmit = async (data: FieldValues) => {
    try {
      setIsLoading(true);
      await forgotPasswordSubmit(userForgotPassword, data.code, data.password);
      setIsLoading(false);
      globalUI.showToast(config.text.loginForgotPassword.changedPasswordMessage, Durations.SHORT);
      navigate(routesOutLogged.login.path);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <Input
        control={control}
        isNumeric
        isRequired
        label={config.text.loginForgotPassword.codeLabel}
        leftIcon={{ name: 'hash', type: 'feather' }}
        name="code"
        placeholder={config.text.loginForgotPassword.codeLabel}
      />
      <Input
        control={control}
        isRequired
        label={config.text.loginForgotPassword.newPasswordLabel}
        leftIcon={{ name: 'lock-outline', type: 'material' }}
        name="password"
        placeholder={config.text.loginForgotPassword.newPasswordLabel}
        secureText
      />
      <Button
        color="secondary"
        isLoading={isLoading}
        onClick={handleSubmit(onSubmit)}
        title={config.text.loginForgotPassword.buttonSendRecovery}
      />
    </View>
  );
};

export default ForgotPasswordRecoveryPassword;
